import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/layout";
import styled from "styled-components";

import MyProfilePicture from "../resources/images/islempenywis_picture.jpg";

const MainContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  margin-top: 2em;
`;

const InnerContainer = styled.div`
  width: 60%;
  @media only screen and (max-width: 776px) {
    width: 100%;
    padding: 5px 15px;
  }
`;

const SectionHeader = styled.div`
  font-family: Oxygen, sans-serif;
  font-size: 20px;
  color: #111;
  margin: 25px auto 15px auto;
`;

const SectionContent = styled.div`
  font-family: Oxygen, sans-serif;
  font-size: 18px;
  color: #555;
`;

const StandAloneLink = styled.a`
  display: block;
  font-size: 18px;
  text-decoration: none;
  color: #5390c5;
`;

const HorizontalFlexContainer = styled.div`
  display: inline-flex;
  flex-direction: row;
  width: 100%;
`;

const ImageContainer = styled.div`
  width: ${({ width }) => (width ? width : 50)}px;
  height: ${({ height }) => (height ? height : 50)}px;
  border-radius: 5px;
  margin-right: 15px;
  img {
    width: 100%;
    height: 100%;
  }
  @media only screen and (max-width: 1280px) {
    width: 800px;
    height: 150px;
  }
`;

const AboutPage = () => {
  return (
    <MainContainer>
      <InnerContainer>
        <SectionHeader>About US</SectionHeader>
        <SectionContent>
          <HorizontalFlexContainer>
            <ImageContainer width={250} height={170}>
              <img src={MyProfilePicture} />
            </ImageContainer>
            I'm Islem Maboud a Full Stack Web Developer and a Tutorials Maker at
            Youtube and Ipenywis.com love exploring new things and creating Open
            source projects
          </HorizontalFlexContainer>
        </SectionContent>
        <SectionHeader>Contact US</SectionHeader>
        <SectionContent>
          For more info about the Open Source project like the ButterflyEditor
          or for Bussiness Inqueries I'm always welcoming your Emails and
          Messages and I will be very happy to have a chat with you.
          <StandAloneLink href="mailto:islempenywis@gmail.com">
            islempenywis@gmail.com
          </StandAloneLink>
        </SectionContent>
        <SectionHeader>Join our Learning Community</SectionHeader>
        <SectionContent>
          We put High-Quality Video/Written tutorials on Youtube and on our
          Learning Platform Ipenywis. You're Welcome to Join us and Start
          Learning.
          <StandAloneLink
            href="https://www.youtube.com/channel/UCMm15RFnHUvM-aSc50e7R9A"
            target="_blink"
          >
            Youtube Channel
          </StandAloneLink>
          <StandAloneLink href="https://ipenywis.com" target="_blink">
            Ipenywis Learning Platform
          </StandAloneLink>
        </SectionContent>
      </InnerContainer>
    </MainContainer>
  );
};

export default AboutPage;
